import http from '../../../plugins/axios';

export default {

    /**
     * 获取信息列表
     * @param data
     * @returns {*}
     */
    getMessageList(data) {
        return http.get({
            url: '/cms/cms/message/info/list',
            data
        })
    },

    /**
     * 删除信息
     * @param data
     * @returns {*}
     */
    deleteMessageByIds(data) {
        return http.post({
            url: '/cms/cms/message/info/delete',
            data,
            dataType: 'form'
        })
    },

    /**
     * 标记已读
     * @param data
     * @returns {*}
     */
    readMessageById(data) {
        return http.post({
            url: '/cms/cms/message/info/read',
            data,
            dataType: 'form'
        })
    },

}
